import { useState, useEffect } from "react";
import { useStore } from "react-redux";
import _ from "lodash";

import { Card } from '@mui/material';

import { ListDisplay } from '../../Component/ListDisplay/ListDisplay';

import { constants } from '../../Constants/constants';
import { getList } from "../../helper/baseFetch";
import { generateTableCellToMultiLanguageName } from "../../helper/util";

export const RestaurantApproveList = ({ newListTitles, newFilter }) => {
  const store = useStore();
  const [restaurantApproveListList, setRestaurantApproveListList] = useState([]);
  const [ready, setReady] = useState(false);
  const resource = "restaurantApprove";

  const restaurantApproveListTitleList = newListTitles ? newListTitles : [
    {
      key: constants.LIST_DISPLAY_TYPE.STRING,
      value: "channel",
      sort: true
    }, {
      key: constants.LIST_DISPLAY_TYPE.STRING,
      value: "restUrlId",
      sort: true
    }, {
      key: constants.LIST_DISPLAY_TYPE.STRING,
      value: "name",
      sort: false,
      minSize: true,
    }, {
      key: constants.LIST_DISPLAY_TYPE.STRING,
      value: "email",
      sort: true
    }, {
      key: constants.LIST_DISPLAY_TYPE.STRING,
      value: "address",
      sort: false,
      minSize: true,
    }, {
      key: constants.LIST_DISPLAY_TYPE.STRING,
      value: "salesName",
      sort: true
    }, {
      key: constants.LIST_DISPLAY_TYPE.DATE,
      value: "salesCreateTimestamp",
      sort: true
    }, {
      key: constants.LIST_DISPLAY_TYPE.BOOLEAN,
      value: "uploadedBankInfo",
      sort: true
    }, {
      key: constants.LIST_DISPLAY_TYPE.BOOLEAN,
      value: "uploadedBr",
      sort: true
    }, {
      key: constants.LIST_DISPLAY_TYPE.STRING,
      value: "approvalStatus",
      sort: true
    }, {
      key: constants.LIST_DISPLAY_TYPE.DATE,
      value: "approvalDate",
      sort: true
    }, {
      key: constants.LIST_DISPLAY_TYPE.DATE,
      value: "updateTimestamp",
      sort: true
    },
  ];

  const listFilters = newFilter ? newFilter : [
    {
      className: "filter-input",
      label: { resource: resource, key: "channel" },
      value: '',
      type: constants.TYPE.SELECT,
      selectValue: constants.CHOICES.PAYMENT.CHANNEL,
      name: "channel",
      size: constants.SIZE.SMALL
    },
    {
      className: "filter-input",
      label: { resource: resource, key: "restUrlId" },
      clear: true,
      value: '',
      name: "restUrlId",
      size: constants.SIZE.SMALL
    },
    {
      className: "filter-input",
      label: { resource: resource, key: "name" },
      clear: true,
      value: '',
      name: "name",
      size: constants.SIZE.SMALL
    },
    {
      className: "filter-input",
      label: { resource: resource, key: "email" },
      clear: true,
      value: '',
      name: "email",
      size: constants.SIZE.SMALL
    },
    {
      className: "filter-input",
      label: { resource: resource, key: "address" },
      clear: true,
      value: '',
      name: "address",
      size: constants.SIZE.SMALL
    },
    {
      className: "filter-input",
      label: { resource: resource, key: "approvalStatus" },
      value: constants.APPROVAL_STATUS.PENDING,
      type: constants.TYPE.SELECT,
      selectValue: constants.CHOICES.RESTAURANT_APPROVE.STATUS,
      name: "approvalStatus",
      size: constants.SIZE.SMALL
    },
  ];

  const [param, setParam] = useState({
    path: "",
    page: 0,
    rowsPerPage: 10,
    sort: 'updateTimestamp',
    direction: 'DESC',
    listFilters: listFilters,
    count: 0,
  })

  function onChangeParam(value) {
    value.count = value.count + 1;
    setParam(value);
  }

  function onChangeListFilters(list) {
    let tempParam = _.cloneDeep(param);
    tempParam.listFilters = list;
    tempParam.page = 0;
    onChangeParam(tempParam);
  }

  function onChangeListSort(sortItem) {
    let tempParam = _.cloneDeep(param);
    tempParam.sort = sortItem;
    tempParam.direction = tempParam.direction === "DESC" ? "ASC" : "DESC";
    onChangeParam(tempParam);
  }

  function onChangeListPage(page) {
    let tempParam = _.cloneDeep(param);
    tempParam.page = page;
    onChangeParam(tempParam);
  }

  function onChangeListRowsPerPage(rowsPerPage) {
    let tempParam = _.cloneDeep(param);
    tempParam.page = 0;
    tempParam.rowsPerPage = rowsPerPage;
    onChangeParam(tempParam);
  }

  useEffect(() => {
    let tempParam = _.cloneDeep(param);
    const filter = {};
    tempParam.listFilters.forEach((filterItem) => {
      if (filterItem.value !== '' && filterItem.value !== undefined) {
        filter[filterItem.name] = filterItem.value;
      }
    })

    getList(constants.PATH.APPROVAL.RESTAURANT, { sort: { field: tempParam.sort, order: tempParam.direction }, filter: filter, pagination: { page: tempParam.page + 1, perPage: tempParam.rowsPerPage } }, (payload) => {
      payload.map((item) => {
        item.name = generateTableCellToMultiLanguageName(item.tcName, item.enName, item.scName);
        item.address = generateTableCellToMultiLanguageName(item.tcAddress, item.enAddress, item.scAddress);
        return item
      });
      setRestaurantApproveListList(payload);
      setReady(true)
    }, undefined, store);

  }, [param.count]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    ready &&
    <Card className="card-wrapper overflow">
      <ListDisplay
        page={param.page}
        rowsPerPage={param.rowsPerPage}
        onChangeListSort={onChangeListSort}
        resource={resource}
        dataList={restaurantApproveListList}
        sort={param.sort}
        direction={param.direction}
        listTitles={restaurantApproveListTitleList}
        listFilters={param.listFilters}
        onChangeListPage={onChangeListPage}
        onChangeListRowsPerPage={onChangeListRowsPerPage}
        createBtn={false}
        onChangeListFilters={onChangeListFilters}
        redirectPath={"/" + constants.PATH.APPROVAL.RESTAURANT + "/"}
      />
    </Card>
  )
};